// Navigation state carried by in-app links so destination pages' back buttons can pop
// history (`navigate(-1)`) instead of linking to a fallback URL. Direct loads, bookmarks,
// and external links carry no state, so `isFromInsideApp` returns false for them.
export const FROM_INSIDE_APP_STATE = { fromInsideApp: true } as const;

export const isFromInsideApp = (state: unknown): boolean =>
  typeof state === 'object' && state !== null && 'fromInsideApp' in state && state.fromInsideApp === true;
